<div>
  <!-- FILTERS -->
  <sp-filters-toolbar></sp-filters-toolbar>

  <!-- LAST REVIEWER DATA -->
  <sp-last-reviewed-by [reviewerData]="reviewerData"> </sp-last-reviewed-by>

  <div class="main-wrapper">
    <div class="wrapper-content">
      <sp-actions-toolbar (createNewRecord)="createNewRecord.emit($event)"></sp-actions-toolbar>

      <sp-floor-container></sp-floor-container>
    </div>
  </div>
</div>
